var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWebdev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "177px",
    height: "150px",
    viewBox: "0 0 177 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "webdev-1",
    transform: "translate(32.000000, 27.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,47.6912893 C69.5660914,44.2013941 67.8304569,40.7114989 65.2270052,38.5303144 L20.5344173,2.75888864 C14.8936053,-1.60348036 7.08325012,-0.731006558 2.74416392,4.94007314 C-1.59492228,10.6111528 -0.727105036,18.463417 4.91370702,22.825786 L37.4568535,49 L4.91370702,75.174214 C-0.727105036,79.536583 -1.59492228,87.3888472 2.74416392,93.0599269 C7.08325012,98.7310066 14.8936053,99.6034804 20.5344173,95.2411114 L65.2270052,58.5972118 C68.2643655,55.9797904 70,52.4898952 70,48.5637631 L70,47.6912893 Z",
    id: "Path",
    fill: "#0D55FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.927755,72 L63.2119216,72 C62.7769122,72 61.9068935,72 61.4718841,72.4310345 L32.326257,95.2758621 C31.8912477,95.7068966 31.8912477,96.137931 32.326257,96.5689655 C32.326257,97 32.7612664,97 33.1962757,97 L102.362764,97 C109.322914,97 115.413045,90.9655172 114.978035,83.637931 C114.543026,76.7413793 108.452895,72 101.927755,72",
    id: "Path",
    fill: "#00C9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,84.5 C114,91.3965517 108.396552,97 101.5,97 C94.6034483,97 89,91.3965517 89,84.5 C89,77.6034483 94.6034483,72 101.5,72 C108.396552,72 114,77.6034483 114,84.5",
    id: "Path",
    fill: "#7000F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWebdev);
export default __webpack_public_path__ + "static/media/logo-webdev.25d88bfc768c8439fdb33efc0d8e6015.svg";
export { ForwardRef as ReactComponent };